export const SPACE = process.env.REACT_APP_SPACE || "";
export const ACCESS_TOKEN = process.env.REACT_APP_ACCESSTOKEN || "";
